<template>
  <div class="nav-link text-nowrap">
    <router-link
      class="nav-link d-inline"
      v-tippy="{ arrow: true, theme: 'light-border' }"
      :content="$t('message.account.topup_account')"
      :to="{ name: 'topup-account' }"
    >
      <!-- <i class="fa fa-file-invoice-dollar"></i> -->
      Баланс
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      balance: 0,
    };
  },
  computed: {
    formatted_balance() {
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
      }).format(this.balance);
    },
  },
  mounted() {
    axios.get(window.base + "/account/balance").then((response) => {
      this.balance = parseFloat(response.data);
    });
    this.$root.$on("reduceBalance", (amount) => {
      console.log("reduce", amount);
      this.balance -= amount.price;
    });
  },
};
</script>
